var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../../di";
import { UserNote } from "../UserNote";
import { Availability } from "../Availability";
let UserNoteAvailabilityService = class UserNoteAvailabilityService {
    constructor(userNote) {
        this.userNote = userNote;
        makeAutoObservable(this);
    }
    get availability() {
        return Availability.boolean({
            MaxLengthExceeded: UserNote.MAX_LENGTH !== null &&
                this.userNote.value !== null &&
                this.userNote.value.length > UserNote.MAX_LENGTH,
        });
    }
};
UserNoteAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof UserNote !== "undefined" && UserNote) === "function" ? _a : Object])
], UserNoteAvailabilityService);
export { UserNoteAvailabilityService };
